import { ISubscription } from "../models/Subscription";
import $api from "../http";
import { IUserSubscriptionHistory } from "../models/SubscriptionHistory";

class SubscriptionServiceClass {
  async createSubscription(model: Omit<ISubscription, "id">) {
    return await $api.post<boolean>("api/subscriptions/create", model);
  }

  async getAllSubscriptions(searchValue: string | null) {
    return await $api.get<ISubscription[]>(
      `api/subscriptions/get-all?searchValue=${searchValue || ""}`
    );
  }

  async updateSubscription(id: string, model: Omit<ISubscription, "id">) {
    return $api.put<boolean>(`api/subscriptions/update/${id}`, model);
  }

  async deleteSubscription(id: string) {
    return await $api.delete<boolean>(`api/subscriptions/delete/${id}`);
  }

  async getClientSubscriptionHistoryWithPagination(
    id: string,
    currentPage: number | undefined,
    pageSize: number | undefined
  ) {
    return $api.get<{ items: IUserSubscriptionHistory[]; total: number }>(
      `api/user-subscriptions-history/get-all/${id}?&currentPage=${currentPage}&pageSize=${pageSize}`
    );
  }
}

export const SubscriptionService = new SubscriptionServiceClass();
